import { VerifyMatchTarget } from './verify-match-types';

/**
 * Stable identity for a verify-match row so navigation can find the current
 * item after the list refreshes or is rebuilt.
 */
export function getVerifyMatchTargetKey(target: VerifyMatchTarget): string {
  if (target.kind === 'mention') {
    return `mention:${target.mention.id}`;
  }

  const customId = target.match.audio?.customId ?? '';
  return `spot:${target.match.datetime}:${customId}:${target.match.playedDuration}`;
}
